import { sentryConfig } from '@/config';
import * as Sentry from '@sentry/react';

if (sentryConfig?.dsn) {
  Sentry.init(sentryConfig);
}
